import React, { useEffect, useState } from "react";
import { Modal, Spin, Button, Popover} from "antd";
import { useDispatch } from "react-redux";
import { setMentally, setNewMentally } from "../../slices/riskSlice";

const TableCellMentallyNew = ({item, addNew}) => {

    const dispatch = useDispatch();
    const [mentally2, setStateMentally2] = useState("");
    const [checkedItem, setCheckedItem] = useState(null);
    const [checkedIdmentally, setCheckedIdmentally] = useState("");

	const [addMentally2, setAddMentally2] = useState(false);
    const [mentally, setStateMentally] = useState([]);
    const [mentallyArray, setStateMentallyArray] = useState([]);
    
    const [mentallyArrayUl, setStateMentallyArrayUl] = useState([]);

    return (
        <>
            {mentallyArray.map((element, index) => 
                <>
                    {element
                        &&
                        <div className={`hovers ${index}`}>
                            <ul style={{padding: '0', margin: '0'}}>
                                {
                                    // console.log(mentallyArrayUl)
                                    mentallyArrayUl.map((item, indx) =>
                                        (indx == index) && item.map((i, ind) =>
                                        i &&
                                        <li class="autofilss">
                                            <input type="text" className="autofilssInput" onChange={(e) => dispatch(setNewMentally([index.toString(), ind, e.target.value ]))}></input>
                                        </li>
                                    ))
                                }
                                <div className="autofilss">
                                    <button onClick={(e) => {e.preventDefault(); setStateMentallyArrayUl(mentallyArrayUl.map((item, ind) => (ind == index) ? item = [...item, true] : item));}}>+ Add</button>
                                </div>  
                            </ul>
                        </div>   
                    }    
                </>
            )}
            <div className="autofilss">
                <button onClick={(e) => {e.preventDefault(); setStateMentallyArray([...mentallyArray, true]); setStateMentallyArrayUl([...mentallyArrayUl, [true]])}}>+ Add</button>
            </div>  
        </>
    )
};

export default TableCellMentallyNew;